import React, { Component } from 'react'
import './index.scss'

import i18n from '@/i18n'
import { Trans } from 'react-i18next'
import { GetBusinessTemplateCategory } from '@/utils/Global'
class EcommerceSection extends Component {

    render() {
		const BUSINESS_TEMPLATE_CATEGORY = GetBusinessTemplateCategory()
        return (
            <div className="ecommerce-section-root-container">
                <div className="heading">
                    <Trans
                        i18nKey="web.newhome.ecommerce.title"
                        components={[
                            <br />,
                            <span />,
                        ]}
                    />
                </div>
                <div className="subtitle">
                    <img
                        className="premium"
                        src="https://front.videomonster.com/images-u6yd72dy/web/premium.svg"
                        alt=""
                    />
                    E-Commerce
                </div>
                <div className="video-area">
                    <video
                        src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/ecommerce/64abdd364abc3f459ee8a4c9.mp4"
                        autoPlay
                        loop
                        muted
                    />
                    <video
                        src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/ecommerce/64df29bc0d07ff005e59093a.mp4"
                        autoPlay
                        loop
                        muted
                    />
                    <video
                        src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/ecommerce/64f17ebd730c854ccc0db40d.mp4"
                        autoPlay
                        loop
                        muted
                    />
                    <video
                        src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/v3/ecommerce/6551bf38914c6a005efab2f7.mp4"
                        autoPlay
                        loop
                        muted
                    />
                </div>
                <div
                    className="setting-btn"
                    onClick={() =>
                        this.props.history.push({
                            pathname: "/designselect",
                            state: {
                                businessCategory:
                                    BUSINESS_TEMPLATE_CATEGORY
                                        .Ecommerce_Shopping.key,
                            },
                        })
                    }
                >
                   {i18n.t("web.newhome.ecommerce.button")}
                </div>
            </div>
        );
    }
}

export default EcommerceSection